import { isBoolean } from "lodash";
import holiday_jp from "@holiday-jp/holiday_jp";
import moment from 'moment'

export const isDateDisabled = ({ day, validations }) => {
  if (validations.start_date && day < moment(validations.start_date)) return true;
  if (validations.end_date && day > moment(validations.end_date)) return true;

  const isHoliday = holiday_jp.isHoliday(day);
  const isHolidayEnabled = isBoolean(validations.holiday) && validations.holiday;

  const dayOfWeek = moment(day).locale('en').format('dddd').toLowerCase();
  const isDayOfWeekEnabled = isBoolean(validations[dayOfWeek]) && validations[dayOfWeek];

  if (validations.prioritize_day_of_week) return !isDayOfWeekEnabled
  if (isHoliday) return !isHolidayEnabled;
  if (isDayOfWeekEnabled) return false;

  return true;
};
